<script setup lang="ts">
import { computed, ref, watch } from 'vue'

const props = withDefaults(defineProps<{
    name?: string
    src?: string
}>(), {
    name: '用户',
    src: '',
})

const initial = computed(() => Array.from(props.name.trim() || '用户')[0]?.toLocaleUpperCase() || '用')
const hue = computed(() => {
    let hash = 0
    for (const character of props.name) { hash = (hash * 31 + (character.codePointAt(0) || 0)) >>> 0 }
    return 190 + hash % 145
})
const imageFailed = ref(false)
const showImage = computed(() => Boolean(props.src) && !imageFailed.value)

watch(() => props.src, () => imageFailed.value = false)
</script>

<template>
    <span class="user-avatar" :style="{ '--avatar-hue': hue }" aria-hidden="true">
        <img v-if="showImage" :key="src" :src="src" alt="" decoding="async" @error="imageFailed = true">
        <span v-else>{{ initial }}</span>
    </span>
</template>

<style scoped>
.user-avatar {
    display: inline-grid;
    overflow: hidden;
    aspect-ratio: 1;
    place-items: center;
    border: 1px solid hsl(var(--avatar-hue) 44% 48% / 20%);
    border-radius: 999px;
    color: hsl(var(--avatar-hue) 58% 38%);
    background: hsl(var(--avatar-hue) 52% 91%);
    font-family: Georgia, 'Times New Roman', serif;
    font-weight: 700;
    line-height: 1;
}

.user-avatar img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

:global(:root:not([data-theme='light'])) .user-avatar,
:global(.theme-dark) .user-avatar {
    border-color: hsl(var(--avatar-hue) 48% 70% / 18%);
    color: hsl(var(--avatar-hue) 62% 78%);
    background: hsl(var(--avatar-hue) 32% 21%);
}
</style>
